import { render, staticRenderFns } from "./OrderPaymentHistory.vue?vue&type=template&id=57d735b2&scoped=true"
import script from "./OrderPaymentHistory.vue?vue&type=script&lang=js"
export * from "./OrderPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./order-dialog.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OrderPaymentHistory.vue?vue&type=style&index=1&id=57d735b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d735b2",
  null
  
)

export default component.exports